<template>
    <div class="page">
        <div class="fill58"></div>
        <pageBreadcrumb :option="nav_option" />

        <div class="peopleIntro">
            <div class="wrap">
                <div class="flexBox">
                    <el-image class="peopleImg" :src="info.image" :preview-src-list="[info.image]" :initial-index="0" fit="cover"></el-image>
                    <div class="rightBox">
                        <div class="title">{{ lang == 'en' ? info.enTitle : info.title }}</div>
                        <div class="intro">{{ lang == 'en' ? info.enContent1 : info.content1 }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="aboutPeople">
            <div class="wrap">
                <div class="title">{{ $t('关于艺术家') }}</div>
                <div class="line"></div>
                <div class="introText">{{ lang == 'en' ? info.enContent2 : info.content2 }}</div>
                <div class="videoBox" v-if="videoList && videoList.length > 0">
                    <div class="videoItem" v-for="(item, index) in videoList" :key="index" @click="showVideo(item)">
                        <el-image class="elImg" :src="item.image" fit="cover"></el-image>
                        <div class="playBtn"></div>
                    </div>
                </div>

                <el-pagination
                    v-if="videoList && videoList.length > 0"
                    class="elpagination"
                    background
                    layout="prev, pager, next"
                    :total="count"
                    :current-page="page"
                    :page-size="pageNum"
                    @current-change="changePage"
                >
                </el-pagination>
            </div>
        </div>

        <div class="equipment" v-if="info.pr_info && info.pr_info.length">
            <div class="wrap">
                <div class="title">{{ $t('艺术家设备') }}</div>
                <div class="line"></div>
                <div class="swiperBox">
                    <el-carousel indicator-position="outside" height="300px">
                        <el-carousel-item v-for="(item, index) in listFormate(info.pr_info)" :key="index">
                            <div class="swiperItem">
                                <div class="item" v-for="(item2, index2) in item" @click="goDetail(item2)">
                                    <div class="imgBox">
                                        <el-image class="swiperImg" :src="item2.thumb" fit="cover"></el-image>
                                        <div class="imgActive"></div>
                                    </div>
                                    <div class="productFlexBox">
                                        <div class="text">{{ lang == 'en' ? item2.enTitle : item2.title }}</div>
                                        <div class="addIcon"></div>
                                    </div>
                                </div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
        </div>
        <div class="fill100"></div>

        <el-dialog
            :title="videoTitle"
            custom-class="modal-custom"
            :close-on-click-modal="false"
            :visible.sync="videoWinShow"
            :before-close="onModalClose"
        >
            <div class="videoBox" v-if="videoUrl">
                <ali-video :mediaUrl="videoUrl"></ali-video>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import pageBreadcrumb from '@/components/page/page-breadcrumb.vue'
import aliVideo from '@/components/aliVideo/aliVideo'

export default {
    name: 'artistDetail',
    components: {
        pageBreadcrumb,
        aliVideo,
    },
    data() {
        return {
            nav_option: [
                { title: '首页', path: '/' },
                { title: '签约艺术家', path: '/artistList' },
                { title: '艺术家姓名', path: '' },
            ],
            count: 0,
            page: 1,
            pageNum: 8,
            videoWinShow: false,
            id: '',
            info: {},
            videoList: [],
            videoTitle: this.$t('视频'),
            videoUrl: '',
        }
    },
    computed: {
        listFormate() {
            return (val) => {
                function isArray(arg) {
                    if (typeof Array.isArray === 'undefined') {
                        return Object.prototype.toString.call(arg) === '[object Array]'
                    }
                    return Array.isArray(arg)
                }
                if (val && isArray(val)) {
                    let reviews_group = []
                    let items_length = 4 //4个一组
                    val.forEach((v, i) => {
                        let group_index = Math.floor(i / items_length)
                        if (!reviews_group[group_index]) {
                            reviews_group[group_index] = []
                        }
                        reviews_group[group_index].push(v)
                    })
                    return reviews_group
                } else {
                    return []
                }
            }
        },
        ...mapState([]),
    },
    watch: {},
    created() {
        this.id = this.$route.query.id
        this.nav_option = [
            { title: this.$t('首页'), path: '/' },
            { title: this.$t('签约艺术家'), path: '/artistList' },
            { title: this.$t('艺术家姓名'), path: '' },
        ]
        this.videoTitle = this.$t('视频')
        this.getDetail()
        this.getVideoList()
    },
    methods: {
        goDetail(item) {
            this.$router.push({
                path: 'product-detail',
                query: {
                    id: item.inventory_id,
                },
            })
        },
        async getVideoList() {
            let obj = {
                page: this.page,
                pageNum: this.pageNum,
                artist_id: this.id,
            }
            let res = await this.artistVideoListsAjax(obj)
            if (res && res.code == 200) {
                let data = res.data
                this.count = data.count
                this.videoList = data.list
            }
        },
        artistVideoListsAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'artist_videoLists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        async getDetail() {
            let obj = {
                artist_id: this.id,
            }
            // this.$load.open()
            let res = await this.artistDetailAjax(obj)
            // this.$load.close()
            if (res && res.code == 200) {
                this.nav_option = [
                    { title: this.$t('首页'), path: '/' },
                    { title: this.$t('签约艺术家'), path: '/artistList' },
                    { title: res.data.title, path: '' },
                ]
                this.info = res.data
            }
        },
        artistDetailAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'artist_detail',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        showVideo(item) {
            console.log(item)
            this.videoUrl = item.video_url
            this.$nextTick(() => {
                this.videoWinShow = true
            })
        },
        onModalClose() {
            this.videoUrl = ''
            this.videoWinShow = false
        },
        changePage(page) {
            this.page = page
            this.getVideoList()
        },
    },
}
</script>

<style scoped lang="less">
.wrap {
    width: @width;
    overflow: hidden;
    margin: 0 auto;
}

.equipment {
    width: 100%;
    margin-top: 90px;

    .title {
        font-weight: bold;
        font-size: 30px;
        color: #000000;
        line-height: 34px;
        margin-bottom: 20px;
    }

    .line {
        width: 100%;
        height: 2px;
        background: rgba(0, 0, 0, 0.8);
        margin-bottom: 66px;
    }

    .swiperBox {
        width: 100%;

        .swiperItem {
            width: 100%;
            height: 300px;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .item {
                width: 390px;
                height: 300px;
                margin-right: 11px;
                cursor: pointer;

                .imgBox {
                    width: 100%;
                    height: 250px;
                    margin-bottom: 24px;
                    position: relative;

                    .swiperImg {
                        width: 100%;
                        height: 250px;
                        display: block;
                    }

                    .imgActive {
                        width: 100%;
                        height: 100%;
                        background: rgba(255, 77, 0, 0.3);
                        position: absolute;
                        top: 0;
                        left: 0;
                        z-index: 9;
                        display: none;
                    }
                }

                .productFlexBox {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .text {
                        width: calc(100% - 25px - 20px);
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        font-weight: 400;
                        font-size: 20px;
                        color: #000000;
                        line-height: 20px;
                    }

                    .addIcon {
                        width: 25px;
                        height: 25px;
                        background: url('../../assets/img/artist/add.png') no-repeat;
                        background-size: 100% 100%;
                    }
                }

                &:last-child {
                    margin-right: 0;
                }

                &:hover {
                    .imgActive {
                        display: block;
                    }

                    .text {
                        color: #ff4d00;
                    }

                    .addIcon {
                        background: url('../../assets/img/artist/add2.png') no-repeat;
                        background-size: 100% 100%;
                    }
                }
            }
        }
    }
}

.aboutPeople {
    width: 100%;
    overflow: hidden;

    .title {
        font-weight: bold;
        font-size: 24px;
        color: #000000;
        line-height: 34px;
        margin-bottom: 20px;
    }

    .line {
        width: 100%;
        height: 2px;
        background: rgba(0, 0, 0, 0.8);
        margin-bottom: 66px;
    }

    .introText {
        width: 100%;
        font-weight: 400;
        font-size: 16px;
        color: #888888;
        line-height: 34px;
    }

    .elpagination {
        margin-top: 30px;
        text-align: center;
    }

    /deep/ .modal-custom {
        .videoBox {
            width: 100%;
            height: 500px;
            margin: 0 auto;

            .video {
                display: block;
                width: 100%;
                height: 100%;
            }
        }
    }

    .videoBox {
        margin-top: 115px;
        width: 100%;
        max-height: 530px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;

        .videoItem {
            display: block;
            width: calc((100% - 26px * 3) / 4);
            height: 242px;
            margin-right: 25px;
            background: #ff4d00;
            margin-top: 46px;
            position: relative;
            cursor: pointer;

            &:nth-child(4n) {
                margin-right: 0;
            }

            &:nth-child(-n + 4) {
                margin-top: 0;
            }

            .elImg {
                width: 100%;
                height: 100%;
            }

            .playBtn {
                width: 60px;
                height: 60px;
                background: url('../../assets/img/artist/play.png') no-repeat;
                background-size: 100% 100%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
    }
}

.peopleIntro {
    width: 100%;
    overflow: hidden;
    margin-top: 70px;
    margin-bottom: 90px;

    .flexBox {
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        overflow: hidden;

        .peopleImg {
            width: 346px;
            height: 346px;
        }

        .rightBox {
            width: 1194px;

            .title {
                font-weight: bold;
                font-size: 24px;
                color: #000000;
                line-height: 24px;
                margin-bottom: 40px;
            }

            .intro {
                font-weight: 400;
                font-size: 16px;
                color: #888888;
                line-height: 34px;
            }
        }
    }
}

.fill58 {
    width: 100%;
    height: 58px;
}

.fill100 {
    width: 100%;
    height: 100px;
}
</style>
<style scoped lang="less" src="@/assets/h5css/mobile/artistDetail.less"></style>
